import React from 'react';
import classNames from 'classnames';
import Container from '../lib/Container';

export default function PhoneInputContainer({
    columns,
    spans,
    children,
}) {

    const Classes = classNames({
        "flex !px-0 !pt-0": true,
    })

    return (
        <Container columns={columns || 1} spans={spans} className={Classes}>
            {children}
        </Container>
    )
}
